<template>
    <div class="new-chat">
        <input
            v-model="newThreadName"
            type="text"
            placeholder="Введите имя нового чата"
            class="chat-input"
            @keyup.enter="createThread"
        />
        <div @click="createThread" class="chat-button" role="button" tabindex="0">
            <span class="icon">+</span>
        </div>
    </div>
</template>

<script>
import { yandexApi } from './api/yandex-api';

const userName = localStorage.getItem('USER_NAME');

export default {
    props: {
        onCreated: {
            required: true
        }
    },
    data() {
        return {
            newThreadName: '' // <-- новое поле для имени чата
        };
    },
    methods: {
        async createThread() {
            const threadName = this.newThreadName.trim() || 'Новый чат';

            console.log('Создание чата с именем:', threadName);

            const runBody = {
                userId: userName,
                name: threadName,
                description: "",
            };

            const { data: thread } = await yandexApi.post(`/thread`, runBody);
            thread.processing = false;
            this.newThreadName = ''; // очистка поля после создания
            this.onCreated(thread);
        },
    },
}
</script>

<style scoped>
.new-chat {
  display: flex;
  align-items: center;
  padding: 10px 3px 10px 3px;
  background: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
}

.chat-input {
  flex: 1;
  min-width: 0; /* важно! чтобы не выталкивало кнопку */
  padding: 8px 8px 8px 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  box-sizing: border-box;
}

.chat-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  padding: 8px 12px;
  background-color: #f15540;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  white-space: nowrap;
  height: 12px;
  width: 5px;
  flex: 0 0 auto;
  user-select: none;
  transition: background-color 0.2s;
}

.chat-button:hover {
  background-color: #d94a36;
}

.icon {
  font-weight: bold;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/new-chat.vue